import { css } from '@emotion/react'
import clsx from 'clsx'
import type { ReactNode } from 'react'

import { typo } from '~/@common/styles'
import { mixpanelClient } from '~/@common/utils/trackings/mixpanel'

export type ChallengeTabType = 'ASSIGNED_CHALLENGE' | 'CURRICULUM_CHALLENGE'

type Props = {
  selectedTab: ChallengeTabType
  onSelectTab: (tab: ChallengeTabType) => void
  children: ReactNode
}

const ChallengeTabContainer = ({ selectedTab, onSelectTab, children }: Props) => {
  return (
    <section css={_css}>
      <div className="challenge-tabs">
        <div className="challenge-tab-group">
          <button
            type="button"
            role="tab"
            className={clsx(
              'challenge-tab-button',
              selectedTab === 'ASSIGNED_CHALLENGE' && 'selected',
            )}
            onClick={() => {
              onSelectTab('ASSIGNED_CHALLENGE')
              mixpanelClient.track('선생님설정챌린지_탭_Click')
            }}
          >
            선생님이 설정한 챌린지
          </button>
          <button
            type="button"
            role="tab"
            className={clsx(
              'challenge-tab-button',
              selectedTab === 'CURRICULUM_CHALLENGE' && 'selected',
            )}
            onClick={() => {
              onSelectTab('CURRICULUM_CHALLENGE')
              mixpanelClient.track('단원유형별챌린지_탭_Click')
            }}
          >
            단원 유형별 챌린지
          </button>
        </div>
      </div>
      <div className="challenge-tab-content">{children}</div>
    </section>
  )
}

export default ChallengeTabContainer

const _css = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  background: var(--White);
  border-radius: var(--Radius-300);
  margin: 20px 0 15px;
  box-sizing: border-box;
  overflow: hidden;

  .challenge-tabs {
    flex-shrink: 0;
    position: relative;
    z-index: 2;
    border-radius: var(--Radius-300) var(--Radius-300) 0 0;
    overflow: hidden;
  }

  .challenge-tab-group {
    display: flex;
  }

  .challenge-tab-button {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 16px;
    text-align: center;
    background: var(--Colors-Gray-100);
    color: var(--Colors-Gray-600);
    ${typo.body01}
    cursor: pointer;
    border-bottom: 1px solid var(--Colors-Gray-300);
  }

  .challenge-tab-button + .challenge-tab-button {
    border-left: 1px solid var(--Colors-Gray-300);
  }

  .challenge-tab-button.selected {
    font-weight: 700;
    background: var(--White);
    color: var(--Colors-Gray-900);
    border-top: 2px solid var(--Colors-Gray-900);
    border-bottom: none;
  }

  .challenge-tab-content {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 20px 24px;
  }

  .challenge-tab-content > .container {
    height: 100%;
  }
`
